// import { get } from "lodash";

export default {
  getSchedulesByTeam: (state) => state.workSchedules,
};
